<template xmlns:TabPane="http://www.w3.org/1999/xlink">
  <div>
    <div class=" toph mb16" >
      <span>客户管理</span>
    </div>
     <Tabs v-model="currentTab" class="toph-tabs">
       <TabPane :label="'回访'+' '+visitTotal" name="VISIT"></TabPane>
       <TabPane :label="'生日'+' '+birthdayTotal" name="BIRTHDAY"></TabPane>
    </Tabs>
    <keep-alive>
      <div class="modalnobefore" v-if="currentTab=='VISIT' && projectFid">
        <table-list
          title=""
          :columns="visitColumns"
          :current="visitCurrent"
          :data="visitTableList"
          :total="visitTotal"
          :loading="visitLoading"
          :defaultTem="isVisitShow"
          @change-page="visitChangPage"
          :pageSize="5"
        ></table-list>
        <a @click="go"  style="position: relative; top: -15px;left: 24px" v-if="visitTableList.length !== 0" v-p="{api:'workbench/getPersonVisitLogList'}">查看全部回访</a>
        <img-show :n="imgN" :src="imgSrc"></img-show>
        <handle-modal :n="HandleKey" :visitFid="visitFid" :uid="uid" @refresh="handleRefresh"></handle-modal>
      </div>
    </keep-alive>
    <keep-alive>
      <div class="modalnobefore" v-if="currentTab=='BIRTHDAY' && projectFid" style="padding-bottom: 12px;">
        <table-list
          title=""
          :columns="birthdayColumns"
          :current="birthdayCurrent"
          :data="birthdayList"
          :total="birthdayTotal"
          :loading="birthdayLoading"
          :defaultTem="isBirthdayShow"
          @change-page="birthdayChangPage"
          :pageSize="5"
        ></table-list>
      </div>
    </keep-alive>

  </div>
</template>

<script>
  import TableList from "components/TableList/index";
  import {customerTotalCount,getList,birthdayList} from 'api/workBench'
  import HandleModal from '../../personvisitlog/manage/components/HandleModal'
  import ImgShow from 'components/ImgListShow/index'

  export default {
    name: "Customer",
    components: {
      ImgShow,
      HandleModal,
      TableList
    },
    watch:{
      projectFid() {
        this.birthdaySearchData.page=1
        this.visitSearchData.page=1
        this.birthdayCurrent=1
        this.visitCurrent=1
        this.initData();
      },
      currentTab() {
          if(this.currentTab=='VISIT') {
             this.initVisitTableList();
          }else {
             this.initbirthdayTableList();
          }
      }
    },
    computed:{
    },
    props: {
      projectFid: {
        type: String,
        default: ''
      },
    },
    data() {
      return {
        uid:'',
        visitTotal:0,
        birthdayTotal:0,
        currentTab: 'VISIT',
        //birthday
        birthdayCurrent:1,
        birthdaySearchData: {
          page: 1,
          limit: 5
        },
        birthdayLoading:false,
        birthdayColumns:[
          {
            type: "index",
            key: "index",
            align: "center"
          },
          {
            title:' ',
          },
          {
            title: '合同号',
            key: 'contractCode',
            align: 'center',
            width:180
          },
          {
            title:' ',
          },
          {
            title: '房间/床位号',
            key: 'stockNum',
            align: 'center',
            width:120
          },
          {
            title:' ',
          },
          {
            title: '入住人',
            key: 'name',
            align: 'center',
            width:180
          },
          {
            title:' ',
          },
          {
            title: '性别',
            key: 'sex',
            align: 'center',
            width:120,
          },
          {
            title:' ',
          },
          {
            title: '入住天数',
            key: 'sumCheckInDays',
            align: 'center',
            width:120,
          },
          {
            title:' ',
          },
          {
            title: '年龄',
            key: 'age',
            align: 'center',
            width:120,

          },
          {
            title:' ',
          },
          {
            title: '生日',
            key: 'birthday',
            align: 'center',
            width:120,
          },
          {
            title:' ',
          },
          {
            title: '剩余天数',
            key: 'days',
            align: 'center',
            width:120,
          },
          {
            title:' ',
          },
        ],
        birthdayList:[],
        //visit
        imgN: 0,
        imgSrc: [],
        visitFid:'',
        HandleKey:0,
        currentVisitLog:[],
        visitCurrent:1,
        visitSearchData: {
          shouldVisitDateFrom:new Date(new Date().getTime() - 15*24*60*60*1000),
          shouldVisitDateTo:new Date(new Date().getTime() + 15*24*60*60*1000),
          visitDateFrom:'',
          visitDateTo:'',
          visitStatus: 1,
          stockFid:'',
          page: 1,
          limit: 5
        },
        visitLoading:false,
        isVisitShow:false,
        isBirthdayShow:false,
        visitColumns:[
          {
            type: "index",
            key: "index",
            width: 60,
            align: "center"
          },
          {
            title:' ',
          },
          {
            title: '合同号',
            key: 'contractCode',
            align: 'center',
            width:180
          },
          {
            title:' ',
          },
          {
            title: '房间/床位号',
            key: 'stockNum',
            align: 'center',
            width:120
          },
          {
            title:' ',
          },
          {
            title: '入住人',
            key: 'personName',
            align: 'center',
            width:180,
          },
          {
            title:' ',
          },
          {
            title: '签约日期',
            key: 'signDateStr',
            align: 'center',
            width:120,
          },
          {
            title:' ',
          },
          {
            title: '应回访日',
            key: 'shouldVisitDateStr',
            width:120,
            align: 'center',
          },
          {
            title:' ',
          },
          {
            title: '回访类型',
            key: 'visitTypeName',
            width:100,
            align: 'center'
          },
          {
            title:' ',
          },
          {
            title: '签约类型',
            key: 'contractTypeName',
            width:100,
            align: 'center'
          },
          {
            title:' ',
          },
          {
            title: '租约类型',
            key: 'rentTypeName',
            width:100,
            align: 'center'
          },
          {
            title:' ',
          },
          {
            title: '回访状态',
            key: 'visitStatusName',
            width:100,
            align: 'center'
          },
          {
            title:' ',
          },
          {
            title: '操作',
            key: 'action',
            width:100,
            fixed:'right',
            align: 'center',
            render: (h,params)=>{
              return h('div',[h('a',{
                style: {
                  marginRight: '5px',
                  display: params.row.visitStatus==1?  'inline-block':'none'
                },
                directives:[
                  {
                    name:'p',
                    value:{
                      api:'workbench/handlePersonVisitLog'
                    }
                  }
                ],
                on:{
                  click: () => {
                    const svDate = params.row.shouldVisitDate;
                    const nowDate = new Date();
                    const iDates = parseInt(Math.abs(svDate - nowDate) / 1000 / 60 / 60 / 24);
                    if(iDates>15) {
                      this.$Message.error('请在应回访日前后15天内录入回访')
                    }else {
                      this.visitFid=params.row['fid']
                      this.uid = params.row['customerUid']
                      this.HandleKey++
                    }

                  }
                }
              },'跟进'),])
            }
          },
          {
            title:' ',
          },
        ],
        visitTableList:[]

      }
    },
    methods: {
        //birthday
      birthdayChangPage(n){
        this.birthdayLoading = true;
        this.birthdayCurrent = n;
        this.birthdaySearchData.page = n
        this.initbirthdayTableList()
      },
      initbirthdayTableList() {
        const params={
          ...this.birthdaySearchData,
          projectFid:this.projectFid,
        };
        birthdayList(params).then( res => {
          this.birthdayList = res.data.list
          if(this.birthdayList.length<=0 ) {
            this.isBirthdayShow = true;
          }
          this.birthdayTotal = res.data.total
        }).catch(error=>{
          this.$Message.error('生日提醒加载失败')
        }).finally(()=>{
          this.birthdayLoading = false
        })
      },
      //visit
      visitChangPage(n){
        this.visitLoading = true;
        this.visitCurrent = n;
        this.visitSearchData.page = n
        this.initVisitTableList()
      },
      initVisitTableList() {
        const params={
          ...this.visitSearchData,
          projectFid:this.projectFid,
        };
        getList(params).then( res => {
          this.visitTableList = res.data.list
          if(this.visitTableList.length<=0 ) {
            this.isVisitShow = true;
          }
          this.visitTotal = res.data.total
        }).catch(error=>{
          this.$Message.error('回访列表加载失败')
        }).finally(()=>{
          this.visitLoading = false
        })
      },
      selectItem(selection){
        this.currentVisitLog = selection
      },
      go(){
        this.$router.push({name : 'customer',params:{projectFid:this.projectFid,visitStatus:2,targetTab:'3'}})
      },
      initData() {
          if(!this.projectFid) {
              return;
          }
        this.setCurrentTab();
      },
      setCurrentTab() {
        if(!this.projectFid) {
          return;
        }
        customerTotalCount(this.projectFid).then(res=>{
            this.visitTotal = res.data.visitTotal;
            this.birthdayTotal = res.data.birthdayTotal;
            console.log(this.birthdayTotal+","+this.visitTotal)
            if(this.visitTotal==0&&this.birthdayTotal>0) {
                this.currentTab = 'BIRTHDAY';
                this.initbirthdayTableList();
            }else {
              this.currentTab = 'VISIT';
              this.initVisitTableList();
            }
        })
      },
      handleRefresh () {
        if (this.visitTableList.length === 1) {
          this.visitCurrent = 1
          this.visitSearchData.page = 1
        }
        this.initData()
      }
    },
    created() {
        this.initData();
    },
    mounted() {
      this.initData();
    }
  }
</script>

<style scoped>
  .topitem{
    width: 150px;
    text-align: center;
    line-height: 2.2;


  }
  .activeitem{
    color: #CFA868;
  }
  .itemwrapper{
    border-bottom: 1px solid #f9f9f9;

  }
  .toph{
    display: flex;
    background-color: #F4F4F4 ;
    box-shadow: 0 1px 0 0 #F4F4F4;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px ;
    box-sizing: border-box;
    line-height: 40px;
  }

</style>
